/**
 * Get the next transcript ID in the list
 * @param {string} currentId - Current transcript ID
 * @param {Array} transcripts - Flattened array of transcripts
 * @returns {string|null} - Next transcript ID or null if at end
 */
export function getNextTranscriptId(currentId, transcripts) {
  if (!transcripts || !Array.isArray(transcripts)) return null;
  const currentIndex = transcripts.findIndex((t) => t.id === currentId);
  if (currentIndex !== -1 && currentIndex < transcripts.length - 1) {
    return transcripts[currentIndex + 1].id;
  }
  return null;
}

/**
 * Get the previous transcript ID in the list
 * @param {string} currentId - Current transcript ID
 * @param {Array} transcripts - Flattened array of transcripts
 * @returns {string|null} - Previous transcript ID or null if at beginning
 */
export function getPreviousTranscriptId(currentId, transcripts) {
  if (!transcripts || !Array.isArray(transcripts)) return null;
  const currentIndex = transcripts.findIndex((t) => t.id === currentId);
  if (currentIndex > 0) {
    return transcripts[currentIndex - 1].id;
  }
  return null;
}

/**
 * Flatten assigned tags structure for easier processing
 * @param {Array} assigned_tags - Array of assigned tags with nested values
 * @returns {Array} - Flattened array of tag objects
 */
export function flattenAssignedTags(assigned_tags) {
  return assigned_tags.flatMap((tag) =>
    tag.values.map((value) => ({
      tag_key_id: tag.tag_key_id,
      tag_key: tag.tag_key,
      tag_value_id: value.tag_value_id,
      value_key: value.value_key,
    })),
  );
}

/**
 * Constants for transcript operations
 */
export const MAX_VISIBLE = 3;
